import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  dialogPaper: {
    padding: spacing(2, 3),
    minHeight: 460,
    minWidth: 600
  },
  dialogTitle: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: spacing(2),
    padding: spacing(1)
  },
  modalHeader: {
    display: 'flow'
  },
  categoriesBox: {
    overflow: 'hidden',
    overflowY: 'scroll',
    paddingLeft: spacing(2)
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'right'
  },
  actionButton: {
    marginLeft: spacing(2)
  },
  disabledIcon: {
    padding: spacing(2),
    marginLeft: spacing(2)
  },
  disabledItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: spacing(2)
  },
  subcategoryItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: spacing(2),
    height: '42px',
    cursor: 'pointer'
  },
  arrowHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  arrowFooter: {
    display: 'flex',
    alignItems: 'center'
  },
  arrowFooterIcon: {
    fontSize: '12px',
    color: 'gray',
    width: spacing(4)
  },
  arrowHeaderIcon: {
    cursor: 'pointer',
    marginRight: spacing(1)
  },
  rootCategory: {
    display: 'flex',
    alignItems: 'center'
  }
}))
